import type { Path } from '@geom';
import { immerable } from '@utils';

// Class for runtime edge layout information
export class EdgeLayout {
  [immerable] = true;

  path: Path; // Writable for immer via mutation functions
  opacity = 1; // For animations

  constructor(path: Path, opacity = 1) {
    this.path = path;
    this.opacity = opacity;
  }
}
